import React, { useMemo } from "react";
export const ServicesContext = React.createContext({
    layoutService: {
        addLayoutItem: () => { },
        removeLayoutItem: () => { },
        updateLayoutItem: () => { },
        selectLayoutItem: () => { },
    },
    pageService: {
        onDeletePage: () => { },
        onEditPage: () => { },
        onDuplicatePage: () => { },
        onSelectPage: () => { },
        onCreatePage: () => { },
    },
});
export const ServicesProvider = ({ layoutService, pageService, children, }) => {
    const value = useMemo(() => ({ layoutService, pageService }), []);
    return (React.createElement(ServicesContext.Provider, { value: value }, children));
};
